export class GetRoleResponse {
    'role';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "role",
            "baseName": "role",
            "type": "Role",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRoleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
